import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel, ApiVisa, Core2Config } from '../../shared';
import { ReviewVoteContainerModel } from '../../../../../../models';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class ReviewVoteService extends BaseApiPublicLoginTemplateService<ReviewVoteContainerModel, ReviewVoteContainerModel, ReviewVoteContainerModel> {

    static readonly REVIEW_VOTE_SUB_PATH = 'fi/fi-item/review-votes/';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-item/review-votes';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-item/review-votes';
        this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + ReviewVoteService.REVIEW_VOTE_SUB_PATH + BaseApiPublicLoginTemplateService.PUBLIC_EP;
        this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + ReviewVoteService.REVIEW_VOTE_SUB_PATH + BaseApiPublicLoginTemplateService.LOGIN_ENTITY_EP;
        this.httpClient = http;
    }

    postLogin(dtoObject: ReviewVoteContainerModel, visa: ApiVisa): Observable<ApiResponseModel<ReviewVoteContainerModel>> {
        const loginApiUrl = this.endpoint_path_login_url && visa.api_domain_url ? visa.api_domain_url + this.endpoint_path_login_url : this.apiUrl;

        return this.httpClient.post<ApiResponseModel<ReviewVoteContainerModel>>(
            loginApiUrl,
            dtoObject,
            this.getHttpHeader(visa)
        );
    }
}
